// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// Third party libraries
import Buefy from 'buefy'
import VueLoading from 'vuex-loading'
import VeeValidate from 'vee-validate'

// Buefy
Vue.use(Buefy)

// Vue loading
Vue.use(VueLoading)

// Vee validate
Vue.use(VeeValidate)

Vue.config.productionTip = false

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  vueLoading: new VueLoading({ useVuex: true }),
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js